export default __webpack_public_path__ + "static/media/circle.bb5494c2.svg";